import { useRegion } from '@/composition/useRegion'
import currencyComposition from '@/composition/currency'

import { RegionSmartBannerMap, LocaleSmartBannerMap } from '@/view-models/banner'
import { RegionIdMap } from '@/view-models/region'
import { getIsTaiwanRegion } from '@/utils/utils'

export function useNewUserGift(from?: 'header' | 'elite') {
  const i18n = useI18n()
  const route = useRoute()
  const { regionId: commonRegionId } = useRegion()
  const { getRegionCurrencyID, getDownloadFeedBackByRegion } = currencyComposition()

  const eliteRegionId = computed(() => Number(route.query.region_id) || RegionIdMap.KualaLumpur)
  const regionId = computed(() => (from === 'elite' ? eliteRegionId.value : commonRegionId.value))

  const isTaiwanRegion = computed(() => getIsTaiwanRegion(regionId.value))
  const amount = computed(() => getDownloadFeedBackByRegion(getRegionCurrencyID(regionId.value)))
  const downloadPromoText = computed(() => {
    if (from === 'elite') {
      return i18n.t('elite_redeem_download_app', { amount: amount.value })
    }
    if (!regionId.value) {
      return i18n.t(from === 'header' ? 'download_app_content' : 'app_download_promo_card_content', { amount: '' })
    }
    if (isTaiwanRegion.value) {
      return i18n.t(from === 'header' ? 'download_app_content_movie' : 'app_download_promo_card_content_movie', { amount: amount.value })
    }
    return i18n.t(from === 'header' ? 'download_app_content' : 'app_download_promo_card_content', { amount: amount.value })
  })

  const smartBannerImgFilename = computed(() => {
    if (regionId.value && RegionSmartBannerMap[regionId.value]) {
      return RegionSmartBannerMap[regionId.value]
    }
    return LocaleSmartBannerMap[i18n.locale.value]
  })

  const smartBannerImgPath = computed(() => useAsset(`/images/else/${smartBannerImgFilename.value}`).value as string)

  return {
    downloadPromoText,
    smartBannerImgFilename,
    smartBannerImgPath,
  }
}
